// ============================================================
// Finance → Expenses & Purchases module manifest.
//
// 2026-05-20. Owner: quality-finance (domain) + principal-architect
//   (manifest contract) + firebase-expert (impl).
//
// Spend-tracking + AP cash book. ADMIN TIER ONLY (director/admin/finance).
// Staff + manager never see it (visible() gates on finance.expense.read,
// which only the admin tier holds — see src/industries/*.js roles).
//
// NO dependency on inventory (v1 is pure-spend) — so finance ships in EVERY
// industry pack including Services. (Closes the "Services has no finance"
// gap structurally.)
//
// Routes (sidebar section 'finance', new):
//   - expenses         — list + record/edit/void + KPI strip
//   - finance-reports  — monthly/yearly/tax/e-Invoice/reimbursement + export
//
// Settings cards (category manager + period close) are contributed by the
// settings module wiring, not as routes here (they live in Settings, per
// spec §2.5 — same place tenant-config + HR Bootstrap live).
// ============================================================

export default {
  id:          'finance',
  name:        'Finance',
  version:     '1.0.0',
  description: 'Expenses & Purchases — spend tracking, AP cash book, SST + e-Invoice capture, accountant export. Admin tier only.',

  load: () => import('./index.js'),

  routes: [
    {
      id:      'expenses',
      label:   'Expenses & Purchases',
      icon:    '🧾',
      section: 'finance',
      sidebarPosition: 10,
      visible: (role, hasPerm) => hasPerm('finance.expense.read'),
      mount:   'mountExpenses',
      unmount: 'unmountExpenses'
    },
    {
      id:      'finance-reports',
      label:   'Finance Reports',
      icon:    '📊',
      section: 'finance',
      sidebarPosition: 20,
      visible: (role, hasPerm) => hasPerm('finance.expense.read'),
      mount:   'mountFinanceReports',
      unmount: 'unmountFinanceReports'
    }
  ],

  schemas: [
    'expenses',
    'expensetaxonomy',    // layered classification tree (replaces flat expensecategories, 2026-05-20)
    'expense-audit',
    'expense-periods',
    'counters'            // shared platform counter collection (per-year expense seq)
  ],

  permissions: [
    'finance.expense.read',
    'finance.expense.create',
    'finance.expense.edit',
    'finance.expense.void',
    'finance.period.close',
    'finance.category.manage'
  ],

  // NO hard dependency — pure-spend v1. Ships in every pack incl. Services.
  dependencies: [],

  fitsIndustries: ['manufacturing', 'trading', 'services', 'retail'],

  // Dashboard KPI widgets — role-gated to the admin tier (R3 composition).
  // Spend figures are pricing-sensitive; defaultRoles excludes staff/manager
  // structurally (they also lack finance.expense.read so they never mount).
  dashboardWidgets: [
    { id: 'finance-month-spend-kpi',  label: 'This month spend', section: 'kpi', order: 50,
      defaultRoles: ['director', 'admin', 'finance'] },
    { id: 'finance-unpaid-kpi',       label: 'Unpaid / payable', section: 'kpi', order: 55,
      defaultRoles: ['director', 'admin', 'finance'] },
    { id: 'finance-tax-kpi',          label: 'Tax this month',   section: 'kpi', order: 58,
      defaultRoles: ['director', 'admin', 'finance'] }
  ]
};
